export default __webpack_public_path__ + "static/politica-de-privacidade-19531d28ae832b2ed5de07006bdc56d0.pdf";